//src/services/auth.js
import { encryptAesGcm } from "./crypto_aes";
import { API_BASE_CLIENT as API_BASE, SECRET_KEY } from "../config/vars";


export const sendCode = async (email) => {
    const response = await fetch(`${API_BASE}/login/client/send-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });
    return response.json().then((data) => ({
        ok: response.ok,
        data,
    }));
};

export const registerUser = async (form) => {
    const endpoint = "/login/client/register";

    if (!SECRET_KEY) {
        return {
            ok: false,
            data: { detail: "Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)" },
        };
    }

    const encryptedPassword = await encryptAesGcm(SECRET_KEY, form.password);

    const body = {
        name: form.name,
        email: form.email,
        descriptions: form.descriptions,
        password: encryptedPassword,
        code: form.code,
        service_id: Array.isArray(form.service_ids) && form.service_ids.length === 1 ? parseInt(form.service_ids[0]) : null,
        service_ids: Array.isArray(form.service_ids) ? form.service_ids.map((value) => parseInt(value)).filter((value) => Number.isFinite(value)) : [],
    };

    const response = await fetch(`${API_BASE}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });

    return response.json().then((data) => ({
        ok: response.ok,
        data,
    }));
};

export const getGoogleAuthUrl = () => {
    return `${API_BASE}/login/client/google`;
};
